/**
 * bubblemachine — the public entry point.
 *
 * Ten lines by design (BRIEF §14): import core, import the skin, mount.
 * Everything project-specific lives in `skin/`. Do not add logic here — if
 * something does not fit in a skin, it belongs in `@remidus/web-core`.
 *
 * `basePath` is passed because only this module knows it: the published
 * `@remidus/web-core` bakes its own base as `/`. Without it the first
 * `api('/config')` is `/api/config`, which on projects.remidus.com is
 * answered by the hub, and the page never hydrates.
 */

import '@remidus/web-core/tokens.css'
import './skin/tokens.css'
import './skin/skin.css'

import { mountSite } from '@remidus/web-core'

import skin from './skin/skin'
import { attachSharedAssets } from './skin/assets/shared'

attachSharedAssets()
void mountSite({ skin, basePath: import.meta.env.BASE_URL })
